import { create } from 'zustand';

const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('token'),

  setAuth: (user, token) => {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
    set({ user, token });
  },

  logout: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  hasRole: (roles) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (!user) return false;
    if (typeof roles === 'string') return user.role === roles;
    return roles.includes(user.role);
  },

  isAdmin: () => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return user?.role === 'admin';
  },

  canEdit: (section) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (!user) return false;
    if (user.role === 'admin') return true;
    const permissions = {
      production: ['production_manager'],
      sales: ['sales_manager'],
      warehouse: ['production_manager'],
      lading: ['sales_manager'],
    };
    return permissions[section]?.includes(user.role) || false;
  },
}));

export default useAuthStore;
